export default __webpack_public_path__ + "static/media/group-7@2x.2b699d5d.png";